import Converter from './Converter';
import { shortLanguages } from 'services/locale';
import { CasinoType, ICasinoProviderConfigurationItem } from 'modules/Casino/types/configuration';
import { projectName } from 'modules/Casino/utils/slots';
import { parseCookies } from '../../utils/parseCookies';
import { QueryTypes } from 'modules/Casino/types/enums/api';

const converter = new Converter();

export const config: ICasinoProviderConfigurationItem<Converter> = {
  type: CasinoType.slots,
  authRequired: false,
  gameListUrl: 'bgaming/game/list',
  converter,
  gameListUrlData: {
    getHeaders: () => ({
      headers: {
        'x-partner-name': projectName,
      },
    }),
  },
  sessionUrlData: {
    url: 'bgaming/game/launch',
    method: QueryTypes.GET,
    getQuery: params =>
      `?game_identifier=${params.gameId}&return_url=${encodeURIComponent(
        location.origin,
      )}&deposit_url=${encodeURIComponent(`${location.origin}/deposit`)}&game_language=${
        shortLanguages[params.lang as keyof typeof shortLanguages]
      }`,
    getHeaders: () => ({
      headers: {
        'x-partner-name': projectName,
        'x-partner-authorization': parseCookies(),
      },
    }),
    converter: converter.convertGameUrl,
  },
};
